import { createContext, useContext, useEffect, useState } from "react";

const DICCIONARIO = {
  es: {
    "portal.tagline": "El área de familias de BSpark",
    "home.kicker": "Academia de arte",
    "home.titulo1": "Todo lo de tus peques,",
    "home.titulo2": "en un solo sitio.",
    "home.sub": "Entra con el número de matrícula y tu contraseña. Sin complicaciones.",
    "home.v1t": "Su calendario",
    "home.v1d": "Clases, horarios y reposiciones en un vistazo",
    "home.v2t": "Sus trabajos",
    "home.v2d": "Fotos de sus avances y comentarios del profe",
    "home.v3t": "Tus pagos",
    "home.v3d": "Cuotas, recibos y facturas siempre a mano",
    "login.ayuda": "Usa el número de matrícula que te dimos al inscribir a tu hijo/a.",
    "login.registrar": "Inscribir a mi hijo/a",
    "recuperar.titulo": "Crear una contraseña nueva",
    "recuperar.ayuda": "Escribe tu email y te enviamos un enlace para crearla.",
    "recuperar.enviado": "Si ese email está registrado, en unos segundos recibirás un enlace para crear tu contraseña. Revisa también la carpeta de spam. El enlace caduca en 1 hora.",
    "recuperar.volver": "Volver al acceso",
    "recuperar.enviar": "Enviarme el enlace",
    "comun.email": "Email",
    "portal.login": "Entrar",
    "portal.matricula": "Matrícula del alumno/a",
    "portal.password": "Contraseña",
    "portal.verPassword": "Ver la contraseña",
    "portal.olvido": "He olvidado mi contraseña",
    "portal.registro": "Crear mi cuenta",
    "portal.sinCuenta": "¿Todavía no tienes cuenta?",
    "portal.personal": "Acceso del personal",
    "portal.recepcion": "Recepción",
    "portal.calendario": "Calendario",
    "portal.trabajos": "Trabajos",
    "portal.pagos": "Planes y promociones para ti",
    "portal.planesCta": "Contrata o renueva tu cuota, bonos y ofertas · pago seguro",
    "portal.facturas": "Facturas",
    "portal.buzon": "Buzón",
    "portal.asistenciaPct": "Asistencia",
    "portal.asistidas": "Asistidas",
    "portal.faltas": "Faltas",
    "portal.reposiciones": "Reposiciones",
    "portal.aRecuperar": "Clases a recuperar",
    "portal.bienestar": "Bienestar emocional",
    "portal.bienestarNota": "Indicador orientativo del último mes, no sustituye una evaluación profesional.",
    "portal.bienestarVacio": "Todavía no hay registros de cómo llega a clase este mes.",
    "portal.bienestarPositivo": "Bienestar positivo",
    "portal.bienestarNeutro": "Neutral",
    "portal.bienestarAtencion": "Necesita atención",
    "portal.perfil": "Perfil",
    "portal.asistencia": "Asistencia",
    "portal.salir": "Salir",
    "portal.areaFamilias": "Área de familias",
    "portal.matriculaEtq": "Matrícula",
    "portal.sinSede": "Sin sede",
    "portal.estadoPago": "Estado de pago",
    "portal.sinSuscripcion": "Sin suscripción activa",
    "portal.pagadoHasta": "Clases agendadas hasta el",
    "portal.impagoTitulo": "No hemos podido cobrar tu cuota",
    "portal.impagoTexto": "Sus próximas clases están en pausa. Actualiza el método de pago en la pestaña Pagos y se reactivarán automáticamente.",
    "portal.seguro": "Seguro de recuperación de clases",
    "portal.contratado": "Contratado",
    "portal.noContratado": "No contratado",
    "portal.seguroSi": "Puedes recuperar las clases perdidas.",
    "portal.seguroNo": "Las faltas no son recuperables.",
    "portal.bono": "Clases en bono",
    "portal.clasesCuota": "Clases en tu cuota",
    "portal.diaSemana": "1 día por semana",
    "portal.diasSemana": "días por semana",
    "portal.grupo.suscripciones": "Suscripciones",
    "portal.grupo.bonos": "Bonos",
    "portal.grupo.openday": "Open Day",
    "portal.grupo.extras": "Extras",
    "portal.periodicidad": "Periodicidad",
    "portal.periodo.mensual": "Mensuales",
    "portal.periodo.trimestral": "Trimestrales",
    "portal.periodo.semestral": "Semestrales",
    "portal.periodo.anual": "Anuales",
    "portal.cuantosHijos": "¿Para cuántos hijos?",
    "portal.unHijo": "1 hijo",
    "portal.hijos": "hijos",
    "portal.planes": "Planes y precios",
    "portal.menu": "Menú",
    "legal.terminos": "Términos y Condiciones",
    "legal.privacidad": "Política de Privacidad",
    "legal.cookies": "Política de Cookies",
    "legal.version": "Versión",
    "legal.actualizado": "Última actualización",
    "legal.volver": "Volver al área de familias",
    "legal.aviso": "Documento informativo. La versión en español es la que prevalece.",
    "idioma.es": "Español",
    "idioma.en": "English",
  },
  en: {
    "portal.tagline": "The BSpark family area",
    "home.kicker": "Art academy",
    "home.titulo1": "Everything about your little ones,",
    "home.titulo2": "in one place.",
    "home.sub": "Sign in with the student ID and your password. No fuss.",
    "home.v1t": "Their calendar",
    "home.v1d": "Classes, times and make-up sessions at a glance",
    "home.v2t": "Their artwork",
    "home.v2d": "Photos of their progress and the teacher's notes",
    "home.v3t": "Their payments",
    "home.v3d": "Fees, receipts and invoices always to hand",
    "login.ayuda": "Use the student ID we gave you when you enrolled your child.",
    "login.registrar": "Enrol my child",
    "recuperar.titulo": "Create a new password",
    "recuperar.ayuda": "Enter your email and we'll send you a link to create it.",
    "recuperar.enviado": "If that email is registered, you'll receive a link to create your password in a few seconds. Check your spam folder too. The link expires in 1 hour.",
    "recuperar.volver": "Back to sign in",
    "recuperar.enviar": "Send me the link",
    "comun.email": "Email",
    "portal.login": "Sign in",
    "portal.matricula": "Student ID",
    "portal.password": "Password",
    "portal.verPassword": "Show password",
    "portal.olvido": "I forgot my password",
    "portal.registro": "Create my account",
    "portal.sinCuenta": "Don't have an account yet?",
    "portal.personal": "Staff access",
    "portal.recepcion": "Front desk",
    "portal.calendario": "Calendar",
    "portal.trabajos": "Artwork",
    "portal.pagos": "Plans & offers for you",
    "portal.planesCta": "Book or renew your plan, class packs and offers · secure payment",
    "portal.facturas": "Invoices",
    "portal.buzon": "Inbox",
    "portal.asistenciaPct": "Attendance",
    "portal.asistidas": "Attended",
    "portal.faltas": "Absences",
    "portal.reposiciones": "Make-up classes",
    "portal.aRecuperar": "Classes to make up",
    "portal.bienestar": "Emotional wellbeing",
    "portal.bienestarNota": "Indicative snapshot of the last month; it is not a professional assessment.",
    "portal.bienestarVacio": "No records yet of how they arrive to class this month.",
    "portal.bienestarPositivo": "Positive wellbeing",
    "portal.bienestarNeutro": "Neutral",
    "portal.bienestarAtencion": "Needs attention",
    "portal.perfil": "Profile",
    "portal.asistencia": "Attendance",
    "portal.salir": "Sign out",
    "portal.areaFamilias": "Family area",
    "portal.matriculaEtq": "Student ID",
    "portal.sinSede": "No centre",
    "portal.estadoPago": "Payment status",
    "portal.sinSuscripcion": "No active subscription",
    "portal.pagadoHasta": "Classes booked until",
    "portal.impagoTitulo": "We couldn't charge your fee",
    "portal.impagoTexto": "Upcoming classes are on hold. Update your payment method in the Payments tab and they will resume automatically.",
    "portal.seguro": "Class recovery insurance",
    "portal.contratado": "Active",
    "portal.noContratado": "Not active",
    "portal.seguroSi": "You can make up missed classes.",
    "portal.seguroNo": "Missed classes cannot be made up.",
    "portal.bono": "Classes in credit",
    "portal.clasesCuota": "Classes in your plan",
    "portal.diaSemana": "1 day per week",
    "portal.diasSemana": "days per week",
    "portal.grupo.suscripciones": "Subscriptions",
    "portal.grupo.bonos": "Class packs",
    "portal.grupo.openday": "Open Day",
    "portal.grupo.extras": "Extras",
    "portal.periodicidad": "Billing period",
    "portal.periodo.mensual": "Monthly",
    "portal.periodo.trimestral": "Quarterly",
    "portal.periodo.semestral": "Half-yearly",
    "portal.periodo.anual": "Yearly",
    "portal.cuantosHijos": "How many children?",
    "portal.unHijo": "1 child",
    "portal.hijos": "children",
    "portal.planes": "Plans & prices",
    "portal.menu": "Menu",
    "legal.terminos": "Terms and Conditions",
    "legal.privacidad": "Privacy Policy",
    "legal.cookies": "Cookie Policy",
    "legal.version": "Version",
    "legal.actualizado": "Last updated",
    "legal.volver": "Back to the family area",
    "legal.aviso": "Informative document. The Spanish version prevails.",
    "idioma.es": "Español",
    "idioma.en": "English",
  },
};

const IdiomaContext = createContext(null);
const CLAVE = "bspark_idioma";

export const IdiomaProvider = ({ children }) => {
  const [idioma, setIdioma] = useState(() => {
    const guardado = localStorage.getItem(CLAVE);
    if (guardado) return guardado;
    return (navigator.language || "es").toLowerCase().startsWith("en") ? "en" : "es";
  });

  useEffect(() => {
    localStorage.setItem(CLAVE, idioma);
    document.documentElement.lang = idioma;
  }, [idioma]);

  const t = (clave) => DICCIONARIO[idioma][clave] || DICCIONARIO.es[clave] || clave;
  return (
    <IdiomaContext.Provider value={{ idioma, setIdioma, t }}>{children}</IdiomaContext.Provider>
  );
};

export const useIdioma = () => useContext(IdiomaContext);
